import {StepType} from "@reactour/tour";
import React from "react";

export const mailboxTourSteps:Array<StepType> = [
    {
        selector: `.section-navigation `,
        content:
            <div>
                <h6>Mailboxes</h6>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>,
        position: 'top',
    },
    {
        selector: `.custom-folder-container`,
        content:
            <div>
                <h6>Custom Folders</h6>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>,
        position: 'right',
    },
    {
        selector: `.item-row:not(.mailbox-item-row-header)`,
        content:
            <div>
                <h6>Mail Item</h6>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </div>,
        position: 'right',
    },
]
